import { ReactElement, Fragment } from 'react';
import { Outlet } from 'react-router-dom';

const Associations = (): ReactElement => {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};

export default Associations;
